import { Link } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import './Conference.scss';

const testimonials = [
    {
        text: "The 1WN Global Conference is one of the few platforms where meaningful business conversations happen naturally. I am confident that the 1WN Conference will strike the perfect balance between professionalism and enjoyment.",
        name: "Mr. Nicholas Ezenwata",
        company: "First Move Logistics",
        companylogo: "/images/testimonial/Frame 1707480777.png",
        country: "Togo",
        flag: "https://flagcdn.com/w40/tg.png",
        avatar: "/images/testimonial/mr-nicholas-ezenwata.png",
    },
    {
        text: "I am looking forward to the upcoming conference in Colombo because 1WN always offers the perfect balance of business, networking and destination experience.",
        name: "Mr. Vinet Chadha",
        company: "Combined Logistics Solution Pvt Ltd",
        companylogo: "/images/testimonial/Frame 1707480777-1.png",
        country: "India",
        flag: "https://flagcdn.com/w40/in.png",
        avatar: "/images/testimonial/mr-vineet-chaddha.png",
    },
    {
        text: "They made us play a very nice quiz game the last time. I was one of the winners. 1WN always comes with something new, just like Colombo. I am excited to meet all the freight forwarders.",
        name: "Mr. John Prendergast",
        company: "ACA International Ltd",
        companylogo: "/images/testimonial/Frame 1707480777-2.png",
        country: "Ireland",
        flag: "https://flagcdn.com/w40/ie.png",
        avatar: "/images/testimonial/mr-john-prendergast.png",
    },
    {
        text: "1WN always delivers value beyond expectations. I am especially looking forward to engaging with global leaders in such an inspiring setting.",
        name: "Mr. Fabio Belau",
        company: "Conexo Logistics",
        companylogo: "/images/testimonial/Frame 1707480777-3.png",
        country: "Brazil",
        flag: "https://flagcdn.com/w40/br.png",
        avatar: "/images/testimonial/mr-fabio-belau.png",
    },
    {
        text: "What sets 1WN apart is the quality of its network. I am excited to attend the Colombo conference to reconnect with trusted partners and explore new opportunities.",
        name: "Ms. Juria Zhang",
        company: "PT Benua Central Logistik",
        companylogo: "/images/testimonial/Frame 1707480777-4.png",
        country: "Indonesia",
        flag: "https://flagcdn.com/w40/id.png",
        avatar: "/images/testimonial/ms-juria-zhang.png",
    },
    {
        text: "There is always something powerful about meeting partners face-to-face. I’m excited to reconnect and grow at the 1WN Global Conference 2026.",
        name: "Mr. Tang Ngang Joo",
        company: "JT Cargo Connect Pte Ltd",
        companylogo: "/images/testimonial/Frame 1707480777-5.png",
        country: "Singapore",
        flag: "https://flagcdn.com/w40/sg.png",
        avatar: "/images/testimonial/mr-tang-ngang-joo.png",
    },
];

function Conference2026() {

    const targetDate = new Date('2026-05-14T00:00:00').getTime();
    const videoRef = useRef(null);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.playbackRate = 1;
        }
    }, []);

    const calculateTimeLeft = () => {
        const now = new Date().getTime();
        const difference = targetDate - now;

        if (difference <= 0) {
            return { days: '00', hours: '00', minutes: '00', seconds: '00' };
        }

        return {
            days: String(Math.floor(difference / (1000 * 60 * 60 * 24))).padStart(2, '0'),
            hours: String(Math.floor((difference / (1000 * 60 * 60)) % 24)).padStart(2, '0'),
            minutes: String(Math.floor((difference / 1000 / 60) % 60)).padStart(2, '0'),
            seconds: String(Math.floor((difference / 1000) % 60)).padStart(2, '0'),
        };
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    return (
        <>
            <section className="conference-bg">
                <div className="conference-section">
                    <section className="page-header conference-hero">
                        <img
                            src="/images/banner/colombo-calling.jpeg"
                            
                            alt="One World Network Global Conference 2026"
                            className="conference-banner-img"
                        />
                    </section>

                    <div className="conference-content">
                        <div className="conference-btn-center">
                            <Link to="https://www.cognitoforms.com/_1WNOneWorldNetwork/_1WNGlobalConference2026RegistrationForm"
                                target="_blank"
                                rel="noopener noreferrer"

                                className="thm-btn">
                                Register Now
                            </Link>

                            <a href="https://www.oneworldnetwork.co/conferences/colombo-2026/assets/pdf/sponsorship.pdf" target="_blank" rel="noreferrer" className="thm-btn">
                                Become a Sponsor
                            </a>

                                <a href="https://www.oneworldnetwork.co/conferences/colombo-2026/assets/pdf/our-sponsors.pdf" target="_blank" rel="noreferrer" className="thm-btn">
                                Our Sponsors
                            </a>
                        </div>

                        <h2 className="conference-title">
                            BRINGING TOGETHER <span>TOP FORWARDERS</span>
                            <br />
                            UNDER ONE ROOF
                        </h2>

                        <div className="conference-stats">
                            <div className="stat-box">
                                <div className="stat-icon">
                                    <img src="/images/icon/Delegates.png" alt="Delegates" />
                                </div>
                                <div>
                                    <h2>150+</h2>
                                    <p>DELEGATES</p>
                                </div>
                            </div>

                            <div className='stats'>
                                <div className="stat-box">
                                    <div className="stat-icon">
                                        <img src="/images/icon/Countries.png" alt="Countries" />
                                    </div>
                                    <div>
                                        <h2>70+</h2>
                                        <p>COUNTRIES</p>
                                    </div>

                                </div>
                                <div className="stat-border"></div>
                            </div>


                            <div className="stat-box">
                                <div className="stat-icon">
                                    <img src="/images/icon/1-1 Meeting.png" alt="1-1 Meeting" />
                                </div>
                                <div>
                                    <h2>2000+</h2>
                                    <p>1-1 MEETING</p>
                                </div>
                            </div>
                        </div>

                        <div className="conference-video">
                            <video ref={videoRef} autoPlay muted loop playsInline>
                                <source src="https://www.oneworldnetwork.co/conferences/colombo-2026/assets/videos/brand-video.mp4" type="video/mp4" />
                            </video>
                        </div>
                    </div>

                    <section className="page-header conference-hero">
                        <img
                            src="/images/banner/venue-banner.jpg"
                            alt="One World Network Global Conference 2026"
                            className="conference-banner-img"
                        />
                    </section>
                </div>

                <section className="conference-hero">
                    <a href="https://www.oneworldnetwork.co/conferences/colombo-2026/assets/pdf/agenda.pdf" target="_blank" rel="noreferrer">
                        <img
                            src="/images/banner/agenda-banner.jpeg"
                            alt="Agenda Conference 2026"
                            className="conference-banner-img"
                            style={{ cursor: 'pointer' }}
                        />
                    </a>
                </section>

                <div className="countdown-section">
                    <div className="countdown-heading">COUNTDOWN CLOCK</div>
                    <div className="countdown-wrapper">
                        <div className="countdown-box">
                            <h2>{timeLeft.days}</h2>
                            <h5>Days</h5>
                        </div>
                        <div className="countdown-box">
                            <h2>{timeLeft.hours}</h2>
                            <h5>Hours</h5>
                        </div>
                        <div className="countdown-box">
                            <h2>{timeLeft.minutes}</h2>
                            <h5>Minutes</h5>
                        </div>
                        <div className="countdown-box">
                            <h2>{timeLeft.seconds}</h2>
                            <h5>Seconds</h5>
                        </div>
                    </div>
                </div>

                <div className="testimonials-section">
                    <div className="testimonials-heading">Hear it from Attendees</div>

                    <div className="testimonials-grid">
                        {testimonials.map((t, i) => (
                            <div className="testimonial-item" key={i}>
                                <div className="testimonial-card">
                                    <span className="quote-icon">“</span>
                                    <p className="testimonial-text">{t.text}</p>
                                </div>

                                <div className="testimonial-author">
                                    <img src={t.avatar} alt={t.name} className="author-avatar" />

                                    <div className="author-info">
                                        <p className="author-name">{t.name}</p>
                                        <p className="author-company">{t.company}</p>

                                        {t.companylogo && (
                                            <div className="company-logo-wrap">
                                                <img
                                                    src={t.companylogo}
                                                    alt={`${t.company} logo`}
                                                    className="company-logo"
                                                />
                                            </div>
                                        )}

                                        <div className="author-flag-country">
                                            <img src={t.flag} alt={t.country} />
                                            <span>{t.country}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="testimonials-btn-center">
                        <Link to="https://www.cognitoforms.com/_1WNOneWorldNetwork/_1WNGlobalConference2026RegistrationForm"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="thm-btn">
                            Register Now
                        </Link>

                        <a href="https://www.oneworldnetwork.co/conferences/colombo-2026/assets/pdf/sponsorship.pdf" target="_blank" rel="noreferrer" className="thm-btn">
                            Become a Sponsor
                        </a>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Conference2026;